import React, { useState } from 'react'
import {
	ReturnItemStyle,
	StatusIcon,
	Preview,
	Body,
	Price,
	Name,
	Status,
	Checker,
	CheckerTrue,
	Flow,
	ButtonFlowWrapper,
	NoPreview,
} from './style'
import _ from 'lodash'
import { ButtonBorder } from 'components/Form/Button'
import { useDispatch } from 'react-redux'
import { setItemFlowReq } from 'components/Steps/thunk'
import { removeItemFlow } from 'components/Steps/slices'
import ItemAttributes from 'components/ItemAttributes'
import { FormattedMessage } from 'react-intl'
import { Icon } from 'components/Icon'
import { closeOpenedOrders } from '../../slices'
import { setAlertBottomStatus } from 'store/root-slices'
import { showPopup } from 'components/Modal/slices'
import { formatPrice, stopPropagation } from 'utils/common'

const buttonsTitle = {
	REFUND: 'cancelPurchase',
	EXCHANGE: 'changeColorSize',
	RECLAMATION: 'protestBe',
	COMPLAINT: 'protestBe',
	RETURN: 'cancelPurchase',
}

const ButtonsFLow = ({
	setActiveFlow,
	activeFlow,
	actions,
	onClickAction,
	dispatch,
	orderId,
}) => {
	let keys = {
		EXCHANGE: 'exchange',
		REFUND: 'refund',
		RECLAMATION: 'reclamation',
		COMPLAINT: 'reclamation',
	}
	return actions.map((action, key) => {
		let isClicked = false
		if (action === 'REFUND') {
			isClicked =
				activeFlow.flow &&
				(activeFlow.key === 'RETURN' || activeFlow.key === 'REFUND')
		} else {
			isClicked =
				activeFlow.flow &&
				activeFlow.key ===
					(action === 'RECLAMATION' ? 'COMPLAINT' : action)
		}
		return (
			<ButtonBorder
				key={`action_${key}`}
				uppercase='true'
				onClick={(e) => {
					e.stopPropagation()
					onClickAction(
						keys[action],
						action === 'RECLAMATION' ? 'COMPLAINT' : action,
						isClicked
					)
					dispatch(closeOpenedOrders(orderId))
					dispatch(setAlertBottomStatus('close'))
					if (isClicked) {
						setActiveFlow({ flow: '', key: '' })
					}
				}}
				className={`mr-2 flow-btn-original${
					isClicked ? ' btn-active' : ''
				}`}
			>
				<FormattedMessage
					id={`orders.list.btnGroup.${buttonsTitle[action]}`}
					defaultMessage={action}
				/>
			</ButtonBorder>
		)
	})
}

const ReturnItem = ({
	returnItem = {},
	isChecked = false,
	isStatus = false,
	selectedFlow = '',
	flow = '',
	keyValue = '',
	defaultCurrency = '',
}) => {
	const fieldRef = React.useRef(null)
	const [checker, setChecker] = useState(isChecked)
	let [isImageError, setImageError] = useState(false)
	const [statusOrderItem, setStatusOrderItem] = useState({
		status: isStatus,
		selectedFlow: selectedFlow,
	})
	const [activeFlow, setActiveFlow] = useState({
		flow: flow,
		key: keyValue,
	})
	const dispatch = useDispatch()
	const {
		imageUrl,
		name,
		orderItemId,
		price,
		attributes,
		returned,
		pending,
		orderId,
	} = returnItem

	const clearOrderItem = (isClicked) => {
		setStatusOrderItem(false)
		setActiveFlow({ flow: '', key: '' })

		if (isClicked) {
			setChecker(true)
		} else {
			setChecker(false)
		}

		dispatch(
			removeItemFlow({
				flow: statusOrderItem.selectedFlow,
				orderItemId,
			})
		)
	}
	const handlerButtonFlow = (flow, key, isClicked) => {
		if (!isClicked) {
			setActiveFlow({
				flow,
				key,
			})
			setStatusOrderItem({
				status: true,
				selectedFlow: flow,
			})
			dispatch(
				setItemFlowReq({
					item: _.cloneDeep(returnItem),
					flow,
				})
			)
		} else {
			clearOrderItem(isClicked)
		}
	}

	const handleReturnItem = () => {
		if (returned) {
			dispatch(
				showPopup({
					type: 'returnedItemPopup',
				})
			)
		} else if (pending) {
			dispatch(
				showPopup({
					type: 'pendingItemPopup',
				})
			)
		} else {
			if (!checker) {
				fieldRef.current.scrollIntoView({
					block: 'center',
					behavior: 'smooth',
				})
				setChecker(true)
			} else {
				clearOrderItem()
			}
		}
	}

	let isItemHandled = returned ? 'returned' : pending ? 'pending' : false

	return (
		<ReturnItemStyle
			returned={isItemHandled}
			ref={fieldRef}
			onClick={() => {
				console.log('open')
				handleReturnItem()
			}}
			data-cheker={checker ? 'checker' : ''}
		>
			{!statusOrderItem?.status ? (
				<StatusIcon>
					{isItemHandled === 'returned' ? (
						<Icon
							component='returnedStatusIcon'
							className='returned'
						/>
					) : isItemHandled === 'pending' ? (
						<Icon
							component='pendingStatusIcon'
							className='pending'
						/>
					) : (
						<Checker
							returned={isItemHandled}
							className='empty-status'
						/>
					)}
				</StatusIcon>
			) : (
				<StatusIcon onClick={stopPropagation}>
					<CheckerTrue
						data-id={`${orderItemId}_clicker`}
						//returned={isItemHandled}
						onClick={() => {
							console.log('clear')
							clearOrderItem()
						}}
					>
						<Icon
							component='checkStatusIcon'
							className='checked-status'
						/>
					</CheckerTrue>
				</StatusIcon>
			)}
			<Preview returned={isItemHandled}>
				{imageUrl.length ? (
					isImageError ? (
						<NoPreview>
							<Icon component='noPreview' />
						</NoPreview>
					) : (
						<img
							src={imageUrl[0]}
							alt={name}
							onError={() => {
								setImageError(true)
							}}
						/>
					)
				) : (
					<NoPreview>
						<Icon component='noPreview' />
					</NoPreview>
				)}
			</Preview>
			<Body>
				<Name>{name}</Name>
				<ItemAttributes
					size='small'
					isOrdersPage={true}
					attributes={attributes}
				/>
				<Status>{/*In transit*/}</Status>
			</Body>
			<Price>{formatPrice(price, defaultCurrency)}</Price>
			<Flow checker={checker}>
				<ButtonFlowWrapper className='pt-4'>
					<ButtonsFLow
						setActiveFlow={setActiveFlow}
						activeFlow={activeFlow}
						actions={returnItem.returnActions}
						onClickAction={handlerButtonFlow}
						dispatch={dispatch}
						orderId={orderId}
					/>
				</ButtonFlowWrapper>
			</Flow>
		</ReturnItemStyle>
	)
}
export default ReturnItem
